<template>
  <div>
    <div class="main_bottom fade-in-bottom">
      <img src="../assets/main_bottom.svg" />
    </div>

    <img  class="ml-5 mt-5 jello-horizontal"  :src="'/logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:60px; "/>    
    <div class="slide-top text-center mt-8 lineHeight2" style="color:#E37226;font-size:40px;"> 
      "모두에게 <strong class="font-weight-bold">가치</strong>있는<br>
      최고의 <strong class="font-weight-bold">파트너</strong>"
    </div>
    <div v-if="$store.state.CustomInfo.SiteId != ''" class="slide-top1 text-center ma-5" style="color:#585858;font-size:25px;"> 
      <strong class="font-weight-bold">{{$store.state.CustomInfo.SiteNm}} 방문예약시스템</strong>에 오신 것을 환영합니다.
    </div>
    <div v-if="$store.state.CustomInfo.SiteId == ''" class="flex-wrap d-flex justify-center mt-15 mb-15 slide-top2 ml-10 mr-10">      
      <div v-for="(item, i) in $store.state.zSite" :key="i" class="MenuBtn text-center pa-2"  style="cursor:pointer" @click="clickSite(item)" >
        <img class="mr-0 " :src="'/logo_' + item.id + '.svg'" style="height:100px; " />
      </div>
    </div>
    <div v-else class="flex-wrap d-flex justify-center mt-15 mb-15 slide-top2">
      <div v-if="!isLogin" class="MenuBtn text-center pa-2 heartbeat" @click="goLogin" style="cursor:pointer">
        <img class="mr-0 rotate-in-center1" src="../assets/SKST/DashBoard/main_menu_login.svg" />
        <div class="mt-n2 text-h5 slide-top2">로그인</div>
      </div>
      <div v-else class="MenuBtn text-center pa-2" @click="goLogin" style="cursor:pointer">
        <img class="mr-0 rotate-in-center1" src="../assets/SKST/DashBoard/main_menu_login_not.svg" />
        <div class="mt-n2 text-h5 slide-top2">로그인</div>
      </div>

      <div class="MenuBtn text-center pa-2" @click="DownloadGuide" style="cursor:pointer">
        <img class="mr-0 rotate-in-center2" src="../assets/SKST/DashBoard/main_menu_guide.svg" />
        <div class="mt-n2 text-h5 slide-top3">이용자가이드</div>
      </div>
      
      <div class="MenuBtn text-center pa-2" @click="ShowResistCorp" style="cursor:pointer">
        <img class="mr-0 rotate-in-center3" src="../assets/SKST/DashBoard/main_menu_corp.svg" />
        <div class="mt-n2 text-h5 slide-top3">협력업체등록</div>
      </div>

      <div class="MenuBtn text-center pa-2" @click="ShowPrivacyPolicy('A0007')" style="cursor:pointer">
        <img class="mr-0 rotate-in-center4" src="../assets/SKST/DashBoard/main_menu_user.svg" />
        <div class="mt-n2 text-h5 slide-top3">개인정보 처리 방침</div>
      </div>

      <v-icon style="font-size : 150px;" class="mr-2">mdi-cellphone-iphone</v-icon>

      <div class="MenuBtn text-center pa-2" @click="ShowPrivacyPolicy('A0008')" style="cursor:pointer">
        <img class="mr-0 rotate-in-center5" src="../assets/SKST/DashBoard/main_menu_media.svg" />
        <div class="mt-n2 text-h5 slide-top3">영상정보 처리 기기 운영방침</div>
      </div>
    </div>
    <!-- <div class="text-center"  v-if="($store.state.CustomInfo.SiteId != '' && $store.state.CustomInfo.SiteId != 'SKMA') "> -->
    <div class="text-center"  v-if="($store.state.CustomInfo.SiteId != '' && $store.state.CustomInfo.SiteId != 'SKMA'  && $store.state.CustomInfo.SiteId != 'SKST') ">
      <v-btn @click="ClearSite()" color="grey lighten-2" style="margin-top: -100px; font-size: 14px; color: black; ">다른사이트 선택</v-btn>
    </div>
    <div class="d-xl-none" style="height:100px;"></div>

    <div>
      <v-dialog
        v-model="isLogin"
        width="350">
        <v-card class="pa-1 text-center">
          <v-card-text class="mt-4">
            <v-text-field
              v-model="cId"
              label="ID"
              type="text"
              placeholder="아이디를 입력하세요."
              persistent-placeholder
              v-on:keyup.enter="Setfocus()"
              color="black"
              ref="IDRef"
            ></v-text-field>
            <v-text-field
              v-model="cPassword"
              @keyup="filteringHandlerPwd"
              class="mt-n3"
              :class="{'test_password_style' : show1}"
              ref="PwdRef"
              placeholder="암호를 입력하세요."
              persistent-placeholder
              v-on:keyup.enter="CustomLogin()"
              v-on:keyup.ctrl="CopyByCtrlC($event,cPassword)"
              color="black"
            >
              <template v-slot:label>
                <div style="-webkit-text-security: none;">
                  Password
                </div>
              </template>
              <template v-slot:append>
                <div style="-webkit-text-security: none;">
                  <v-icon @click="show1 = !show1">{{cIconText}}</v-icon>
                </div>
              </template>
            </v-text-field>
            <div>
              <v-btn class="mt-0 mb-2" x-large color="grey darken-3" @click="CustomLogin()" dark block>
                <v-icon class="mr-2">lock_open</v-icon>로그인
              </v-btn>
            </div>

            <div class="d-flex mb-8">
              <div @click="ShowSearchCustom()" dark block style="cursor:pointer">
                아이디/비밀번호/소속회사 찾기
              </div>
              <v-spacer></v-spacer>
              <div @click="ShowResistCustom()" dark block style="cursor:pointer">
                회원가입
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="bResistMsg" persistent max-width="700">
      <v-card>
        <div class="text-h6 font-weight-bold grey--text text--darken-1 lineHeight2 pa-3 pr-4 pl-4">
          <span class="blue--text text-h5 font-weight-medium">{{cCustomNm}}님 </span><span class="text-h6 grey--text text--darken-3" style="font-weight:900;">{{$store.state.CustomInfo.SiteNm}} 방문예약시스템</span>에 오신 것을 환영합니다. <br>
        </div>
        <v-divider class="ml-4 mr-4 mb-5"></v-divider>
        <v-card-text>
          <div class="d-flex align-center justify-center text-subtitle-1 font-weight-medium grey--text text--darken-1" style="height : 40px">회원가입이 완료되었습니다.</div>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" text @click="bResistMsg = false; CustomLogin()" class="font-weight-bold"><v-icon class="mr-2">check_circle</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bChangePwd" max-width="500">
      <v-card>
        <v-card-title class="headline font-weight-bold">
          <div>새로운 비밀번호를 입력하여 주세요.</div>
        </v-card-title>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.Pwd1" :class="{'test_password_style' : bChangeShow1}" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.Pwd1)" dense persistent-placeholder>
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">신규 비밀번호<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="bChangeShow1 = !bChangeShow1">{{cIconText_1}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.Pwd2" :class="{'test_password_style' : bChangeShow2}" @keyup.enter="SetNewPwd()" v-on:keyup.ctrl="CopyByCtrlC($event,editedItem.Pwd2)" dense persistent-placeholder>
                <template v-slot:label>
                  <div style="-webkit-text-security: none;">비밀번호 확인<strong class="red--text">*</strong></div>
                </template>
                <template v-slot:append>
                  <div style="-webkit-text-security: none;">
                    <v-icon @click="bChangeShow2 = !bChangeShow2">{{cIconText_2}}</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-2"></v-divider>
              <v-btn @click="CloseDialog()" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
              <v-btn @click="SetNewPwd()" dark class="ml-2"><v-icon class="mr-2">save</v-icon>저장</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bAskDoTestDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline red--text d-flex">
          보안교육 유효기간이 만료될 예정입니다.
          <v-spacer></v-spacer>
          <v-btn @click="CloseAskDoTestDialog()" class="mt-n1 mr-n3" icon><v-icon size="30">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          보안교육 유효기간이 만료되면 방문예약 신청이 불가합니다.<br>
          원활한 업무진행을 위해 유효기간이 만료되기 전에 미리 보안·안전교육을 이수하시면 좋겠습니다.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <!-- <v-btn color="#0066BC" text @click="GoLoginFromAskDialog()" class="font-weight-bold">로그인 하기<v-icon class="ml-1">lock_open</v-icon></v-btn> -->
          <v-btn color="#0066BC" text @click="GoDoTest(false)" class="font-weight-bold">보안안전교육 바로가기<v-icon class="ml-1">mdi-arrow-right</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bGoTestDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline red--text">
          보안교육 유효기간이 만료되었습니다.
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          보안교육 유효기간이 만료되어 방문예약 신청이 불가합니다.<br>
          보안교육을 다시 받으시면 방문예약 신청이 가능합니다.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="#0066BC" text @click="GoDoTest(true)" class="font-weight-bold">보안안전교육 바로가기<v-icon class="ml-1">mdi-arrow-right</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SearchCustom ref="SearchCustomRef"/>
    <ResistCustom ref="ResistCustomRef" @CloseLogin="CloseLogin" @GoResistLogin="GoResistLogin"/>
    <ChangePwd v-if="bChangeMode" ref="ChangePwdRef" @GoLogin="GoChangePwdLogin"/>
    <PledgeDialog ref="PledgeDialogRef" />
    <ResistCorp ref="ResistCorpRef" @GoLogin="ShowResistCustom()" @GoResistCustom="ShowCorpResistCustom"/>
    <Education ref="EducationRef"/>
    <!-- 대시보드 팝업 창 띄우기 (welcome.sk-materials.com 전용) -->
    <PopUp v-if="isWelcomeMaterialsSite" ref="PopUpRef"/>

    <div style="width:100%; position:fixed; bottom : 0px;">
      <CoreFooter />
    </div>
  </div>
</template>

<script>
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import SHA256 from "sha256";
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

import CoreFooter from "@/components/core/Footer.vue";

import SearchCustom from "./SearchCustom.vue";
import ResistCustom from "./ResistCustom.vue";
import ChangePwd from "./ChangePwd.vue";
import PledgeDialog from "../components/PledgeDialog.vue";
import ResistCorp from "./ResistCorp.vue";
import Education from "./Education.vue";
import PopUp from "./PopUp.vue";


export default {
  components: {
    CoreFooter,
    SearchCustom,
    ResistCustom,
    ChangePwd,
    PledgeDialog,
    ResistCorp,
    Education,
    PopUp,
  },
  data: () => ({
    version : "",
    OpenWindow: null,
    bChangeMode : false,
    bAskDoTestDialog : false,
    bNoAskDoTestDialog : false,
    bGoTestDialog : false,
    isLogin : false,
    cId: null,
    cPassword: null,
    show1 : true,
    CustomInfo: null,
    bResistMsg : false,
    bChangePwd : false,
    bChangeShow1 : true,
    bChangeShow2 : true,
    sNowDate : new Date(),
    cCustomNm : "",
    cTestDate : "",
    editedItem : {
      Pwd1 : "",
      Pwd2 : "",
    },
    defaulteditedItem : {
      Pwd1 : "",
      Pwd2 : "",
    },
    bCheckPwd : [
      {value : "", text : "'"}
    ],
  }),

  computed: {
    cIconText() {
      return this.show1 ? "mdi-eye-off": "mdi-eye"
    },
    cIconText_1() {
      return this.bChangeShow1 ? "mdi-eye-off": "mdi-eye"
    },

    cIconText_2() {
      return this.bChangeShow2 ? "mdi-eye-off": "mdi-eye"
    },
    isWelcomeMaterialsSite() {
      return window.location.hostname === "welcome.sk-materials.com";
    },
  },

  beforeDestroy() {
  },

  mounted () {
    this.version = localStorage.getItem("Version");
    axios
      .get(`/version.json?timestamp=${new Date().getTime()}`)
      .then(res => {
        if (res.data.version != this.version) {
          if (this.version != "") {
            this.deleteCash();
          }

          localStorage.setItem("Version", res.data.version);
          this.version = res.data.version;
        }
      })
      .finally(() =>{
      })

    const currentDomain = window.location.hostname;   

    //왜 basicInfo만 될까? process.env~~이렇게 쓰면 왜 안될까..?
    
    
    if (currentDomain == "localhost" || currentDomain == "welcome.skairplus.com" || currentDomain == "skvisitair.m-4.co.kr") {
      BasicInfo.DEFAULT_SITE = "SKMA";                
    } 

    if (currentDomain == "visit.skspecialty.com") {
      BasicInfo.DEFAULT_SITE = "SKST";                
    } 
    // if (currentDomain == "visit.skspecialty.com" ||  window.location.port === "8083") {
    //   BasicInfo.DEFAULT_SITE = "SKST";                
    // } 

    // if (currentDomain == "localhost" || currentDomain == "welcome.skairplus.com") {
    //   BasicInfo.DEFAULT_SITE = "SKMA";                
    // }

    if (BasicInfo.DEFAULT_SITE == "SKMA") {
      this.$store.state.CustomInfo.SiteId = BasicInfo.DEFAULT_SITE;
      this.$store.state.CustomInfo.SiteNm = this.getSiteNm(this.$store.state.CustomInfo.SiteId);
      this.$store.state.CustomInfo.SiteTel = this.getSiteTel(this.$store.state.CustomInfo.SiteId);        
    } 
    else if (BasicInfo.DEFAULT_SITE == "SKST"){
      this.$store.state.CustomInfo.SiteId = BasicInfo.DEFAULT_SITE;
      this.$store.state.CustomInfo.SiteNm = this.getSiteNm(this.$store.state.CustomInfo.SiteId);
      this.$store.state.CustomInfo.SiteTel = this.getSiteTel(this.$store.state.CustomInfo.SiteId);     
    } 
    else {
      let SiteId = localStorage.getItem("SiteId");
      if (SiteId == undefined || SiteId == "") {
        localStorage.setItem("SiteId","");
        this.ClearSite();
      } else {
        // welcome.sk-materials.com에서 SKST가 localStorage에 남아있으면 초기화 후 사이트 선택 화면으로
        if (currentDomain == "welcome.sk-materials.com" && SiteId == "SKST") {
          this.ClearSite();
          return;
        }
        this.$store.state.CustomInfo.SiteId = SiteId;
        this.$store.state.CustomInfo.SiteNm = this.getSiteNm(this.$store.state.CustomInfo.SiteId);
        this.$store.state.CustomInfo.SiteTel = this.getSiteTel(this.$store.state.CustomInfo.SiteId);  
      }
    }
    document.title = this.$store.state.CustomInfo.SiteNm + " 방문예약시스템";



    setTimeout(() => {
      if (BasicInfo.TEST_MODE) {
        // this.cId = "iron28";
        // this.cPassword = "0612Cjy!"

        // this.CustomLogin();
      }      
    }, 100);
  },

  // watch: {
  //   bGoTestDialog(newVal) {
  //   if (newVal) {
  //     // 신규가입의 경우 dialog가 열린 직후 교육 자동 실행
  //     this.GoDoTest(true);
  //   }
  // }
  // },

  created () {
  },

  methods: {
    deleteCash(){
      // caches
      //   .keys()
      //   .then(c => {
      //     for (const i of c) {
      //       caches.delete(i);
      //     }
      //   })
      //   .then(() => {
      //     location.reload(true);
      //   });
    },

    ClearSite() {
      localStorage.setItem("SiteId","");
      this.$store.state.CustomInfo.SiteId = "";
      this.$store.state.CustomInfo.SiteNm = this.getSiteNm(this.$store.state.CustomInfo.SiteId);
      this.$store.state.CustomInfo.SiteTel = this.getSiteTel(this.$store.state.CustomInfo.SiteId);
      document.title = this.$store.state.CustomInfo.SiteNm + " 방문예약시스템";
      
      // 팝업 다시 표시 (welcome.sk-materials.com 전용)
      if (this.isWelcomeMaterialsSite && this.$refs.PopUpRef) {
        this.$refs.PopUpRef.getPOP();
      }
    },

    getSiteNm(id) {
      if (id == "") {
        return ""; 
      } 
      if(id == "SKMA"){
        return "SK에어플러스"
      }
      if (id === "SKST") {
        return "SK스페셜티"
      }
      for (let i = 0; i < this.$store.state.zSite.length; i++) {
        if (this.$store.state.zSite[i].id == id) {
          return this.$store.state.zSite[i].title;
        }   
      }
      return;
      // return "SK에어플러스";
    },

    getSiteTel(id) {
      for (let i = 0; i < this.$store.state.zSite.length; i++) {
        if (this.$store.state.zSite[i].id == id) {
          return this.$store.state.zSite[i].tel;
        }        
      }
      return;
      // return "054-630-8114";
    },

    clickSite(item) {
      // welcome.sk-materials.com에서 SKST 선택 시 초기화 후 사이트 선택 화면으로
      if (window.location.hostname == "welcome.sk-materials.com" && item.id == "SKST") {
        this.ClearSite();
        return;
      }
      localStorage.setItem("SiteId",item.id);
      this.$store.state.CustomInfo.SiteId = item.id;
      this.$store.state.CustomInfo.SiteNm = this.getSiteNm(this.$store.state.CustomInfo.SiteId);
      this.$store.state.CustomInfo.SiteTel = this.getSiteTel(this.$store.state.CustomInfo.SiteId);

      document.title = this.$store.state.CustomInfo.SiteNm + " 방문예약시스템";
    },

    CopyByCtrlC(event,value) {
      if (event.key.toUpperCase() == "C") {
        navigator.clipboard.writeText(value)
      }
    },

    filteringHandlerPwd(e) {
      let ResultWord = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      this.$refs.PwdRef.lazyValue = ResultWord
    },

    goLogin(){
      this.isLogin = !this.isLogin;
      this.cId = "";
      this.cPassword = "";

      setTimeout(() => {
        this.$refs.IDRef.focus();
      }, 10);
    },

    DownloadGuide() {
      console.log("현재 SiteId:", this.$store.state.CustomInfo.SiteId); // SiteId 출력

      const fileUrl = process.env.VUE_APP_FILE_API + "Files/CustomGuide_" + this.$store.state.CustomInfo.SiteId + ".pdf";
      console.log("파일 다운로드 URL:", fileUrl); // 서버에서 요청하는 URL 출력

      axios({
        url: fileUrl,
            method: 'GET',
            responseType: 'blob', 
            })
            
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'CustomGuide.pdf'); 
              document.body.appendChild(link);
              link.click();
            });
    },

    ShowResistCorp() {
      this.$refs.ResistCorpRef.Open();
    },

    ShowPrivacyPolicy(PledgeId) {
      this.$refs.PledgeDialogRef.ShowDialog(PledgeId, "");
    },

    GoResistLogin(item){
      this.cId = item.cCustomNickId
      this.cPassword = item.cPwd
      this.cCustomNm = item.cCustomNm

      this.bResistMsg = true
      this.bGoTestDialog = false
    },

    GoChangePwdLogin(TestDate) {
      this.bChangeMode = false
      this.Checktest(TestDate)
    },

    Setfocus() {
      this.$refs.PwdRef.focus();
    },

    CloseLogin() {      
      this.isLogin = false;
      this.ShowResistCorp();
    },

    CustomLogin() {
      console.log(process.env.VUE_APP_UIL_API);

      this.editedItem  = Object.assign({}, this.defaulteditedItem);
      this.cId = Util.RemoveBlank(this.cId)
      this.cPassword = Util.RemoveBlank(this.cPassword)

      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        CustomNickId : this.cId,
        Pwd : SHA256(this.cPassword + "@" + this.cId),
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "CustomLogin", posData , {
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            let date = new Date()
            let refdateTest = Util.sFormatDate(new Date(date.setMonth(date.getMonth()-3)))
            this.CustomInfo = res.data.Result1[0];            

            if (res.data.Result1[0].PwdChangeDate < refdateTest) {
              this.bChangeMode = true;
              setTimeout(() => {
                this.$refs.ChangePwdRef.ShowDialog(res.data.Result1[0], this.cPassword, res.data.Result2[0].cTestDate);
              }, 10);
            } else {
              this.Checktest(res.data.Result2[0].cTestDate);
            }
          } else if (res.data.ResultCd == "99" || res.data.ResultCd == "01" || res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox", "로그인에 실패하였습니다.", res.data.Msg);
          } else if (res.data.ResultCd == "04" || res.data.ResultCd == "06") {
            EventBus.$emit("onShowMsgBox", "보안 규정 위반", res.data.Msg);
          } else if (res.data.ResultCd == "08") {
            EventBus.$emit("onShowMsgBox", "비밀번호 5회 오류로 인해 잠겨있는 계정 입니다.", res.data.Msg);
          } else if (res.data.ResultCd == "10") {
            this.CustomInfo = res.data.Result1[0]
            this.cTestDate = res.data.Result2[0].cTestDate
            this.bChangePwd = true;
          } else {
            EventBus.$emit("onShowMsg",true, res.data.Msg);
          }
        })
        .catch(err =>{ 
          EventBus.$emit("onShowMsg",true, err);
       })  
    },

    CheckPW(cPwd,cCustomNickId,cBirth) {
      if(!Util.CheckPWFormNew(cPwd)) {
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호는 영문+숫자(10자리) 또는 영문+특수기호(10자리) 또는 영문+숫자+특수기호(8자리)로 설정해주세요.");
        return false;
      }

      if(/(\w)\1\1/.test(cPwd)) {
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호는 같은 문자를 3번 이상 사용하실 수 없습니다.");
        return false;
      }

      if(cPwd.search(cCustomNickId)>-1) {
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 아이디가 포함되었습니다.");
        return false;
      }
      
      if(cPwd.search(cBirth)>-1) {
        EventBus.$emit("onShowMsgBox", "비밀번호 형식이 올바르지 않습니다.","비밀번호에 생년월일이 포함되었습니다.");
        return false;
      }

      return true;
    },

    SetNewPwd() {
      let TestBirth = this.CustomInfo.Birth.substring(5,7) + this.CustomInfo.Birth.substring(8,10)

      if (this.editedItem.Pwd1 == "") {
        EventBus.$emit("onShowMsgBox", "신규 비밀번호가 입력되지 않았습니다.","신규 비밀번호를 입력하여 주세요.");
        return
      }

      if (!this.CheckPW(this.editedItem.Pwd1,this.cId,TestBirth)) {
        return;
      }

      if (this.editedItem.Pwd2 == "") {
        EventBus.$emit("onShowMsgBox", "비밀번호 확인이 입력되지 않았습니다.","신규 비밀번호와 동일하게 입력하여 주세요.");
        return
      }

      if (!this.CheckPW(this.editedItem.Pwd2,this.cId,TestBirth)) {
        return;
      }

      if (this.editedItem.Pwd1 != this.editedItem.Pwd2){
        EventBus.$emit("onShowMsgBox", "비밀번호가 일치하지 않습니다.","신규 비밀번호와 확인 칸을 확인하여 주세요.");
        return
      }

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        cCustomId : this.CustomInfo.CustomId,
        cCustomNickId : this.CustomInfo.CustomNickId,
        cNewPwd : this.$store.state.cAES256Encrypt(this.editedItem.Pwd1),
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SetNewPwd", posData , {
            headers: {
              "Authorization": this.CustomInfo.Token
            }
          })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.bChangePwd = false;
            this.editedItem = Object.assign({}, this.defaulteditedItem);
            EventBus.$emit("onShowMsg", false, "비밀번호 변경이 완료되었습니다.");
            this.Checktest(this.cTestDate);
          } else if (res.data.ResultCd == "02"){
            this.CloseDialog()
            EventBus.$emit("onShowMsgBox", "비밀번호 변경에 실패 하였습니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg", true, "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err =>{ 
          EventBus.$emit("onShowMsg",true, err);
        })  
    },

    CloseDialog() {
      this.cTestDate = "";
      this.bChangePwd = false;
      this.editedItem  = Object.assign({}, this.defaulteditedItem);
    },

    Checktest(cTestDate) {
      if (cTestDate == null || cTestDate == ""){
        this.bGoTestDialog = false
        this.GoDoTest(true)
      } else {
        var refdate = new Date(cTestDate.substring(0,10));
        refdate.setMonth(refdate.getMonth() + 6)
        refdate.setHours(0, 0, 0, 0)

        var now = new Date();
        now.setHours(0, 0, 0, 0)

        if (refdate <= now) {
          this.bGoTestDialog = true
        } else {
          if (Util.bCheckNotiDoTest(cTestDate) && !this.bNoAskDoTestDialog) {            
            this.bAskDoTestDialog = true
          } else {            
            this.$store.dispatch("login", this.CustomInfo)
          }
        }
      }
    },

    ShowSearchCustom() {
      this.$refs.SearchCustomRef.Open();
    },

    ShowResistCustom() {
      this.$refs.ResistCustomRef.Open();
    },

    ShowCorpResistCustom(ResultData) {
      this.$refs.ResistCustomRef.OpenRun(ResultData);
    },

    GoLoginFromAskDialog() {
      this.bAskDoTestDialog = false
      this.$store.dispatch("login", this.CustomInfo)
    },

    GoDoTest(bShowNoMsg) {
      this.$refs.EducationRef.Open(this.CustomInfo, bShowNoMsg);
    },

    CloseAskDoTestDialog() {
      this.bAskDoTestDialog = false;
      this.bNoAskDoTestDialog = true;
    },
  }
};
</script>

<style scoped>
  /* .essetial_input :deep(.v-input__slot) { */
  /* .essetial_input :deep(input) {
    background-color: #F1F3F4;
  } */

  .test_password_style { 
    -webkit-text-security:disc;
  }

  .MenuBtn {
    opacity: 0.85;
    font-weight: bolder;
  }

  .MenuBtn:hover {
    opacity: 1;
    color : #E37226;
    font-weight: 900 !important;
    background: #FFFFFF22;
    border-radius: 20px;
    box-shadow: 0px 0px 20px #00000022;
  }

  .jello-horizontal {
    -webkit-animation: jello-horizontal 0.9s both;
    -webkit-animation-delay: 1s;
    animation: jello-horizontal 0.9s both;
    animation-delay: 1s;
  }


  @-webkit-keyframes jello-horizontal {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    30% {
      -webkit-transform: scale3d(1.25, 0.75, 1);
              transform: scale3d(1.25, 0.75, 1);
    }
    40% {
      -webkit-transform: scale3d(0.75, 1.25, 1);
              transform: scale3d(0.75, 1.25, 1);
    }
    50% {
      -webkit-transform: scale3d(1.15, 0.85, 1);
              transform: scale3d(1.15, 0.85, 1);
    }
    65% {
      -webkit-transform: scale3d(0.95, 1.05, 1);
              transform: scale3d(0.95, 1.05, 1);
    }
    75% {
      -webkit-transform: scale3d(1.05, 0.95, 1);
              transform: scale3d(1.05, 0.95, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }
  @keyframes jello-horizontal {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    30% {
      -webkit-transform: scale3d(1.25, 0.75, 1);
              transform: scale3d(1.25, 0.75, 1);
    }
    40% {
      -webkit-transform: scale3d(0.75, 1.25, 1);
              transform: scale3d(0.75, 1.25, 1);
    }
    50% {
      -webkit-transform: scale3d(1.15, 0.85, 1);
              transform: scale3d(1.15, 0.85, 1);
    }
    65% {
      -webkit-transform: scale3d(0.95, 1.05, 1);
              transform: scale3d(0.95, 1.05, 1);
    }
    75% {
      -webkit-transform: scale3d(1.05, 0.95, 1);
              transform: scale3d(1.05, 0.95, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }


  .slide-top1 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.3s;
    animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.3s;
  }
  .slide-top2 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.8s;
    animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.8s;
  }
  .slide-top3 {
    -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1s;
    animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 1s;
  }

  
  .rotate-in-center1 {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 0.9s;
    animation-delay: 0.9s;
  }

  .rotate-in-center2 {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.2s;
    animation-delay: 1.2s;
  }

  .rotate-in-center3 {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.5s;
    animation-delay: 1.5s;
  }

  .rotate-in-center4 {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 1.8s;
    animation-delay: 1.8s;
  }

  .rotate-in-center5 {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    -webkit-animation-delay: 2.1s;
    animation-delay: 2.1s;
  }

 @-webkit-keyframes rotate-in-center {
  0% {
    -webkit-transform: rotate(-360deg);
            transform: rotate(-360deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
    opacity: 1;
  }
}
@keyframes rotate-in-center {
  0% {
    -webkit-transform: rotate(-360deg);
            transform: rotate(-360deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
    opacity: 1;
  }
}


.lineHeight2{
  line-height: 150%
}

.login_capton_nor{
  position: relative;
  left : 0px;
  top : 3px;
  overflow: hidden; 
  word-break: break-all; 
  white-space: normal; 
  width:210px;     
}

.login_capton_phone{
  position: relative;
  left : 0px;
  top : 3px;
  overflow: hidden; 
  word-break: break-all;
  white-space: normal; 
  width:175px;     
}

  div .v-messages .theme--light {
    -webkit-text-security : none !important;
  }

</style>
